import axios from '@/axios'
export default {
  //我的积分
  async ucPoints(params) {
    return await axios.post('/uc/userPoint/ucPoints', params, { des: '我的积分', sTime: new Date().getTime() })
  },
  //积分任务
  async ucPointsTask(params) {
    return await axios.post('/uc/userPoint/ucPointsTask', params, { des: '积分任务', sTime: new Date().getTime() })
  },
  //升级操作
  async ucPointsUpgrade(params) {
    return await axios.post('/uc/userPoint/ucPointsUpgrade', params, { des: '升级操作', sTime: new Date().getTime() })
  },
  //积分规则
  async ucPointsRule(params) {
    return await axios.post('/uc/userPoint/ucPointsRule', params, { des: '积分规则', sTime: new Date().getTime() })
  },
  //积分明细
  async ucPointsInfo(params) {
    return await axios.post('/uc/userPoint/ucPointsInfo', params, { des: '积分明细', sTime: new Date().getTime() })
  },
  //积分消耗
  async ucPointsConsume(params) {
    return await axios.post('/uc/userPoint/ucPointsConsume', params, { des: '积分消耗', sTime: new Date().getTime() })
  },
  //基础认证
  async getUserinfo(params) {
    return await axios.post('/uc/user/userinfo/identityInfoPc', params, { des: '基础认证', sTime: new Date().getTime() })
  },
}


// WEBPACK FOOTER //
// ./src/api/integration.js